module.exports = __webpack_public_path__ + "index/img/gongzhonghao.7d5ca249.png";